import { createApiClient, getAuthHeaders } from "@/lib/api-client";

import type {
  ConversationLogEntry,
  ConversationLogsQuery,
  ConversationLogsResponse,
} from "./conversation-logs-types";

const logsApi = createApiClient({
  baseUrl: `${import.meta.env.VITE_API_URL ?? "http://localhost:3001"}/assistant`,
  getAuthHeaders,
});

export async function fetchConversationLogs(
  query: ConversationLogsQuery
): Promise<{ entries: ConversationLogEntry[]; total: number }> {
  const params = new URLSearchParams();
  params.set("startTime", query.startTime);
  params.set("endTime", query.endTime);

  if (query.userId) {
    params.set("userId", query.userId);
  }
  if (query.sessionId) {
    params.set("sessionId", query.sessionId);
  }
  if (query.action) {
    params.set("action", query.action);
  }
  if (query.limit !== undefined) {
    params.set("limit", String(query.limit));
  }

  const response = await logsApi.get<ConversationLogsResponse>(`/logs?${params.toString()}`);
  return { entries: response.data, total: response.meta.total };
}
